module.exports = __webpack_public_path__ + "static/gab-logo-671ffc50e99006691994e6413c71a40c.png";